// @ts-check
import React from 'react';
import {
  Histogram as DataUiHistogram,
  BarSeries,
  withParentSize,
  XAxis,
  YAxis,
} from '@data-ui/histogram';

const ResponsiveHistogram = withParentSize(({ parentWidth, parentHeight, ...rest }) => (
  <DataUiHistogram width={parentWidth} height={parentHeight} {...rest} />
));

class Histogram extends React.Component {
  render() {
    return (
      <ResponsiveHistogram
        ariaLabel="My histogram of ..."
        orientation="vertical"
        cumulative={false}
        normalized={false}
        binCount={25}
        valueAccessor={datum => datum}
        binType="numeric"
        renderTooltip={({ event, datum, data, color }) => (
          <div>
            <div>
              <strong>Scheduled within:</strong>
            </div>
            <strong style={{ color }}>
              {datum.bin0} to {datum.bin1} hours
            </strong>
            <div>
              <strong>count </strong>
              {datum.count}
            </div>
            <div>
              <strong>cumulative </strong>
              {datum.cumulative}
            </div>
          </div>
        )}
      >
        <BarSeries animated binnedData={this.props.binnedData /* or binnedData={...} */} />
        <XAxis />
        <YAxis />
      </ResponsiveHistogram>
    );
  }
}

export { Histogram };
